import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/Card/observers/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'

const defaultCardState = []

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.cardId]: [
          ...defaultCardState,
        ]
      }
    case ADD:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: addUniqueValueToArray({
          array: state[action.payload.cardId],
          value: action.payload.userId,
          index: action.payload.index
        })
      } : state
    case ADD_ARRAY: {
      if (!state[action.payload.cardId]) return state

      const newState = { ...state }

      action.payload.array.forEach(userId => {
        newState[action.payload.cardId] = addUniqueValueToArray({
          array: newState[action.payload.cardId],
          value: userId
        })
      })

      return newState
    }
    case REMOVE:
      return state[action.payload.cardId] ? {
        ...state,
        [action.payload.cardId]: state[action.payload.cardId].filter(userId => userId !== action.payload.userId)
      } : state
    default: return state
  }
}

export function add ({ cardId, userId, index }) {
  return {
    type: ADD,
    payload: {
      cardId,
      userId,
      index
    }
  }
}

export function addArray ({ cardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      cardId,
      array
    }
  }
}

export function remove ({ cardId, userId }) {
  return {
    type: REMOVE,
    payload: {
      cardId,
      userId
    }
  }
}
